import { render, staticRenderFns } from "./xw-label-value.vue?vue&type=template&id=3507c274&scoped=true"
import script from "./xw-label-value.vue?vue&type=script&lang=js"
export * from "./xw-label-value.vue?vue&type=script&lang=js"
import "./xw-label-value.vue?vue&type=style&index=0&id=3507c274&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507c274",
  null
  
)

export default component.exports